import { $api } from '#/api/client'
import type { IActiveAnnouncement } from '#interfaces/announcement'
import { isAnnouncementVariant } from '#interfaces/announcement'

interface IFetchActiveAnnouncementsResponse {
  announcements: IActiveAnnouncement[]
  isLoading: boolean
}

const mapActiveAnnouncement = (item: { id: string; message: string; variant: string }): IActiveAnnouncement => ({
  id: item.id,
  message: item.message,
  variant: isAnnouncementVariant(item.variant) ? item.variant : 'info',
})

export const useFetchActiveAnnouncements = (): IFetchActiveAnnouncementsResponse => {
  const { data, isLoading } = $api.useQuery(
    'get',
    '/announcements/active',
    {},
    {
      staleTime: 60_000,
      refetchInterval: 60_000,
      select: (response): IActiveAnnouncement[] => response.member.map(mapActiveAnnouncement),
    },
  )

  return {
    announcements: data ?? [],
    isLoading,
  }
}
